var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_19",
    x: 2.368,
    y: 0,
    width: 13.153,
    height: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2-Dashboard_Design-Final-Copy-2",
    "data-name": "2-Dashboard_Design-Final-Copy-2",
    transform: "translate(-32 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32 175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M16,1a2,2,0,0,1,2,2V18a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V3A2,2,0,0,1,2,1ZM13.05,12.875H4.95a.95.95,0,0,0,0,1.9h8.1a.95.95,0,1,0,0-1.9Zm0-5.937H4.95a.95.95,0,0,0,0,1.9h8.1a.95.95,0,1,0,0-1.9Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -3)",
    filter: "url(#Path_19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19-2",
    "data-name": "Path 19",
    d: "M6.365,0h5.06a.6.6,0,0,1,.51.284l.5.8a.6.6,0,0,1-.51.916H5.968a.6.6,0,0,1-.537-.867l.4-.8A.6.6,0,0,1,6.365,0Z",
    transform: "translate(0 3)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.c2ae1ba94efedcf0b49f4d5b9b9eedec.svg";
export { ForwardRef as ReactComponent };